import React from 'react';

import '../../styles/pcr.scss';

export default ({ children }: { children: React.ReactNode }) => {
  return <div className="pcr-data-container">{children}</div>;
};
